/**
 * Created by yougen.zhuangyg on 2014/11/25.
 */
var map = {
   'arabic': 'ar-sa',
   'german': 'de-de',
   'en': 'en-us',
   'spanish': 'es-es',
   'french': 'fr-fr',
   'italian': 'it-it',
   'japanese': 'ja-jp',
   'korean': 'ko-kr',
   'dutch': 'nl-nl',
   'portuguese': 'pt-pt',
   'russian': 'ru-ru',
   'thai': 'th-th',
   'turkish': 'tr-tr',
   'vietnamese': 'vi-vi',
   'chinese': 'zh-cn',
   'hindi': 'hindi',
   'hebrew': 'iw-il'
};

module.exports = function(lan){
    lan = String(lan || '').replace('_', '-').toLowerCase();
    return map[lan] || lan;
};
